const KEY_PATTERN=/^[a-z][a-z0-9_]{1,63}$/;

function localeKey(locale){
  return String(locale||'pl').trim().toLowerCase().startsWith('en')?'en':'pl';
}

function text(value,{field,max=120}){
  const result=String(value??'').trim();
  if(!result||result.length>max)throw new TypeError(`${field} is invalid`);
  return result;
}

function integer(value,{field,min=0,max=100000}){
  const number=Number(value);
  if(!Number.isInteger(number)||number<min||number>max)throw new TypeError(`${field} is invalid`);
  return number;
}

export function normaliseWoodKey(value){
  const key=String(value||'').trim().toLowerCase();
  return KEY_PATTERN.test(key)?key:null;
}

export function woodFromRow(row,{locale='pl'}={}){
  if(!row||typeof row!=='object')throw new TypeError('Wood catalogue row is required');
  const key=normaliseWoodKey(row.key);
  if(!key)throw new TypeError('wood key is invalid');

  const lang=localeKey(locale);
  const displayPl=text(row.display_name_pl,{field:'display_name_pl'});
  const displayEn=text(row.display_name_en,{field:'display_name_en'});
  const metadata=row.metadata&&typeof row.metadata==='object'&&!Array.isArray(row.metadata)
    ?Object.freeze({...row.metadata})
    :Object.freeze({});

  return Object.freeze({
    key,
    speciesName:text(row.species_name,{field:'species_name'}),
    displayName:lang==='en'?displayEn:displayPl,
    displayNames:Object.freeze({pl:displayPl,en:displayEn}),
    catalogueVersion:integer(row.catalogue_version??1,{field:'catalogue_version',min:1}),
    sortOrder:integer(row.sort_order??100,{field:'sort_order'}),
    active:row.is_active!==false,
    metadata
  });
}

export function sortWoodCatalogue(items=[]){
  if(!Array.isArray(items))throw new TypeError('Wood catalogue must be an array');
  return Object.freeze([...items].sort((a,b)=>{
    const orderA=Number(a?.sortOrder??100);
    const orderB=Number(b?.sortOrder??100);
    if(orderA!==orderB)return orderA-orderB;
    return String(a?.displayName||a?.key||'').localeCompare(String(b?.displayName||b?.key||''));
  }));
}

export function mapWoodCatalogueRows(rows,{locale='pl'}={}){
  if(!Array.isArray(rows))throw new TypeError('Wood catalogue rows must be an array');
  return sortWoodCatalogue(rows.map(row=>woodFromRow(row,{locale})).filter(item=>item.active));
}
